import { render, staticRenderFns } from "./TheMainMailCenter.vue?vue&type=template&id=e61312e8&scoped=true"
import script from "./TheMainMailCenter.vue?vue&type=script&lang=js"
export * from "./TheMainMailCenter.vue?vue&type=script&lang=js"
import style0 from "./TheMainMailCenter.vue?vue&type=style&index=0&id=e61312e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61312e8",
  null
  
)

export default component.exports